import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-practitioner-avatar',
  templateUrl: './practitioner-avatar.component.html',
  styleUrls: ['./practitioner-avatar.component.scss']
})
export class PractitionerAvatarComponent implements OnInit {

  @Input() public url: string;
  @Input() public name: string;
  @Input() public additionalClass: string;

  public imgUrl: string;
  public isImage: boolean;
  public isInitial: boolean;
  public isDummy: boolean;
  

  ngOnInit() {
    if (this.url) {
      this.isImage = true;
      this.imgUrl = this.url
    } else if (this.name) {
      this.isInitial = true;
      this.imgUrl = this.name;
    } else {
      this.isDummy = true;
    }
  }

}
